module.exports = __webpack_public_path__ + "static/media/betauserbadge.0bb0e7dc.svg";